var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.666 0.335938H2.33268C1.41352 0.335938 0.666016 1.08344 0.666016 2.0026V12.0026C0.666016 12.9218 1.41352 13.6693 2.33268 13.6693H15.666C16.5852 13.6693 17.3327 12.9218 17.3327 12.0026V2.0026C17.3327 1.08344 16.5852 0.335938 15.666 0.335938ZM15.666 2.0026V2.42844L8.99935 7.61427L2.33268 2.42927V2.0026H15.666ZM2.33268 12.0026V4.53927L8.48768 9.32677C8.63361 9.44139 8.81379 9.5037 8.99935 9.5037C9.18491 9.5037 9.36509 9.44139 9.51102 9.32677L15.666 4.53927L15.6677 12.0026H2.33268Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector2);
export default __webpack_public_path__ + "static/media/Vector2.e1a15ae0b278ef111ba861fb7f65f6a1.svg";
export { ForwardRef as ReactComponent };